import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { themes } from "@/mocks/movie";

export default function Themes() {
  const [active, setActive] = useState(themes[0].id);

  return (
    <section id="themes" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <SectionHeading
          eyebrow="Themes"
          title="主题看点：藏在细节里的六个命题"
          description="点击任意主题卡片，展开由影片情节延伸出的具体解读。"
        />

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {themes.map((theme) => {
            const isOpen = active === theme.id;
            return (
              <button
                key={theme.id}
                type="button"
                onClick={() => setActive(isOpen ? "" : theme.id)}
                aria-expanded={isOpen}
                className={`text-left h-full rounded-lg border p-5 md:p-6 cursor-pointer transition-colors ${
                  isOpen
                    ? "bg-primary-50 border-primary-300"
                    : "bg-background-50 border-background-200 hover:border-primary-200"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <span
                    className={`w-11 h-11 rounded-md flex items-center justify-center ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-700"
                    }`}
                  >
                    <i className={`${theme.icon} text-2xl`}></i>
                  </span>
                  <i
                    className={`ri-add-line text-xl text-foreground-400 transition-transform duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  ></i>
                </div>
                <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {theme.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{theme.summary}</p>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100 mt-4" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <p className="overflow-hidden text-sm leading-relaxed text-foreground-700 border-t border-primary-200 pt-4">
                    {theme.detail}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}